<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>

    <div class="container-fluid">
      <div class="d-flex justify-content-end my-3" v-if="!canAccess('client')">
        <button
          v-if="docType === 'ActionPlan' && shouldShowBulkButton"
          class="btn btn-success"
          @click="bulkCreateActionPlans"
        >
          <span>Criar em Massa</span>
        </button>
      </div>
      <b-col sm="12" class="my-3 d-flex align-items-center" v-if="filteredData.length > 0">
        <!-- Input ocupa mais espaço -->
        <multiselect
          class="w-50"
          v-model="selectedItem"
          :options="multiselectData"
          track-by="id"
          label="name"
          placeholder="Pesquisar Documento..."
          :searchable="true"
          :allow-empty="true"
          :clear-on-select="false"
          :close-on-select="true"
        >
        </multiselect>

        <button  
          v-if="docType === 'ActionPlan'"
          class="btn btn-success ml-3"
          v-on:click="openCreateActionPlanModal"
        >
          <span>Novo</span>
        </button>
        <button
          class="btn btn-primary ml-auto"
          v-on:click="exportAPRList()"
          :disabled="zipStatus === 'processing'"
        >
          <span>Exportar Lista</span>
        </button>
        <!-- <button
          v-if="shouldShowZipButton"
          class="btn btn-outline-secondary ml-2"
          :disabled="zipStatus === 'processing'"
          @click="openSelectZipModal"
        >
          <span>Baixar Selecionados</span>
        </button> -->
        <b-dropdown
          v-if="shouldShowZipButton"
          class="ml-2"
          variant="outline-primary"
          right
        >

          <template #button-content>
            <span v-if="zipStatus === 'processing'">
              <b-spinner small class="mr-2" />
              {{ zipCurrentState || 'Gerando ZIP...' }}
              <span v-if="zipProgress">({{ zipProgress }}%)</span>
            </span>

            <span v-else>
              Baixar ZIP
            </span>
          </template>

          <b-dropdown-item-button
            v-if="zipStatus === 'idle'"
            @click="downloadDocumentsZip"
          >
            Gerar ZIP
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-if="zipStatus === 'processing'"
            @click="refreshZipStatus"
          >
            Verificar novamente
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-if="zipStatus === 'ready'"
            @click="openZipDownload"
          >
            Download ZIP
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-if="zipStatus === 'error'"
            @click="downloadDocumentsZip"
          >
            Tentar novamente
          </b-dropdown-item-button>

        </b-dropdown>
      </b-col>
      <div class="row"></div>
      <h5
        v-if="filteredData.length == 0"
        style="text-align: center; color: darkgrey"
      >Nenhum Documento Cadastrado</h5>
      <div v-if="filteredData.length == 0 && docType === 'ActionPlan'" class="d-flex justify-content-center mb-3">
        <button  
          class="btn btn-success"
          v-on:click="openCreateActionPlanModal"
        >
          <span>Novo Plano de Ação</span>
        </button>
      </div>
      <div v-if="filteredData.length > 0">
        <b-table
          :key="currentPage"
          :fields="computedFields"
          :items="data"
        >
          <template v-slot:cell(id)="data">
            <b-button
              v-if="(role === 'client' && docType === 'ActionPlan') || (role !== 'client')"
              variant="link"
              style="margin-top:-5px;"
              @click="openModal('confirm-modal', data.value)"
            >
              <font-awesome-icon icon="trash" color="red" />
            </b-button>
            <router-link :to="{ name: `${docType}`, params: { id: data.value, company_id: localCompanyId }}" style="margin-left:15px;margin-right:15px;"
              class="btn btn-md btn-link"
              tag="button"
            >
              <font-awesome-icon :icon="role == `client` ? `external-link-alt`:`pencil-alt`" />
            </router-link>
            <b-button
              v-if="docType === 'Inventory'"
              variant="link"
              style="margin-top:-5px; display: none;"
              @click="exportInventory(data.value)"
            >
              <font-awesome-icon icon="download" />
            </b-button>
            <span
              v-if="(docType === 'DVS' || docType === 'APR') && exportingDocIds.includes(data.value)"
              class="d-inline-flex align-items-center"
              style="margin-top:-5px; margin-left: 5px;"
            >
              <b-spinner small class="mr-1" />
              <small class="text-muted">{{ docExportLabel(data.value) }}</small>
            </span>
            <b-button
              v-else-if="docType === 'DVS'"
              variant="link"
              style="margin-top:-5px;"
              @click="exportDVS(data.value)"
            >
              <font-awesome-icon icon="download" />
            </b-button>
            <b-button
              v-else-if="docType === 'APR'"
              variant="link"
              style="margin-top:-5px;"
              @click="exportAPR(data.value)"
            >
              <font-awesome-icon icon="download" />
            </b-button>
            <b-button
              v-if="docType === 'Diagnoses'"
              variant="link"
              style="margin-top:-5px;"
              @click="exportDiagnoses(data.value)"
            >
              <font-awesome-icon icon="download" />
            </b-button>
          </template>
          <template v-slot:cell(updated_at)="data">{{formatDate(data.value)}}</template>
          <!-- <template v-slot:cell(machine_name)="data">{{(data.item.machine.name)}}</template> -->
        </b-table>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="filteredData.length"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
      <b-modal
        ref="create-action-plan-modal"
        title="Novo Plano de Ação"
        modal-ok="Criar"
        modal-cancel="Cancelar"
        @ok="handleCreateActionPlan"
      >
        <div class="form-group">
          <label>Selecione uma máquina</label>
          <multiselect
            v-model="selectedMachine"
            :options="machines"
            track-by="id"
            label="name"
            placeholder="Selecione uma máquina"
            :searchable="true"
            :allow-empty="false"
            :clear-on-select="false"
            :close-on-select="true"
            @input="onMachineChange"
          />
          <small v-if="machines.length === 0" class="text-muted">Nenhuma máquina disponível sem plano de ação.</small>
        </div>
        <div class="form-group">
          <label>Selecione uma ou mais APR's</label>
          <multiselect
            v-model="selected_aprs"
            :multiple="true"
            :options="aprs"
            track-by="id"
            label="nameWithMachine"
            placeholder="Selecione uma ou mais APR's"
            :disabled="!selectedMachine.id"
          ></multiselect>
        </div>
        <b-alert v-show="alert_field" :variant="alert_field_type" show>{{
          alert_field_msg
        }}</b-alert>

        <template v-slot:modal-cancel>Cancelar</template>
        <template v-slot:modal-ok>Criar</template>
      </b-modal>
      <b-modal
        ref="confirm-modal"
        title="Excluir Máquina"
        modal-ok="Sim"
        modal-cancel="Não"
        @ok="deleteDocument()"
      >
        Deseja mesmo excluir esse documento?
        <template v-slot:modal-cancel>Cancelar</template>
        <template v-slot:modal-ok>Confirmar</template>
      </b-modal>
      <b-modal
        ref="select-zip-modal"
        title="Selecionar Documentos para Download"
        size="lg"
        @ok="handleSelectZipDownload"
      >
        <div class="d-flex align-items-center justify-content-between mb-2">
          <b-form-checkbox v-model="allSelected" @change="toggleSelectAll">
            Selecionar Todos
          </b-form-checkbox>
          <small class="text-muted">{{ selectedDocuments.length }} de {{ allData.length }} selecionados</small>
        </div>
        <hr class="mt-0" />
        <div style="max-height: 400px; overflow-y: auto; padding: 0 10px;">
          <b-form-checkbox
            v-for="item in allData"
            :key="item.id"
            v-model="selectedDocuments"
            :value="item.id"
            class="mb-2"
          >
            {{ getDocumentLabel(item) }}
          </b-form-checkbox>
        </div>
        <template v-slot:modal-cancel>Cancelar</template>
        <template v-slot:modal-ok>Baixar ZIP</template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from "@/api/axios";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import * as XLSX from "xlsx";

export default {
  name: "list-groups",
  components: {
    Multiselect,
  },
  props: {
    company_id: String,
    doctype: String,
    docTypeText: String,
    machine_id: String,
  },
  data() {
    return {
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      perPage: 8,
      currentPage: 1,
      rows: 4,
      data: [],
      allData: [],
      filteredData: [],
      multiselectData: [],
      selectedItem: { name: 'Todos os Documentos', id: 'all' },
      filter: null,
      filterOn: [],
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "",
          active: true,
        },
      ],
      fields: [
        { key: "number_code", label: "Número" },
        { key: "machine.name", label: "Máquina" },
        { key: "updated_at", label: "Modificado em", sortable: true },
        { key: "id", label: "Ações" },
      ],
      role: localStorage.getItem("auth.role"),
      documentToDelete: null,
      machines: [],
      selectedMachine: {},
      selected_aprs: [],
      aprs: [],
      alert_field: false,
      alert_field_type: "warning",
      alert_field_msg: "",
      aprCount: 0,
      actionPlanCount: 0,
      zipStatus: "idle",
      zipCurrentState: "",
      zipProgress: 0,
      zipDownloadUrl: "",
      zipStatusUrl: "",
      zipPolling: false,
      selectedZipPolling: false,
      componentDestroyed: false,
      exportingDocIds: [],
      docExportState: {},
      attachmentWarningKeys: [],
      selectedDocuments: [],
      allSelected: false,
    };
  },
  beforeDestroy() {
    this.componentDestroyed = true;
  },
  mounted() {
    if (this.company_id) {
      this.localCompanyId = this.company_id;
      localStorage.setItem('company_id', this.company_id);
    } else {
      this.localCompanyId = localStorage.getItem('company_id');
    }

    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }

    this.providerData();

    this.items[2].text = this.documentTypeLabel;

    if (this.docType !== 'ActionPlan' && this.role != "client") {
      this.items.push({
        text: "Novo",
        href: `#/admin/Documents/${this.docType}/${this.company_id || this.localCompanyId}`,
      });
    }
    this.checkSuccessNotification();
    this.initZipStatus();
  },
  methods: {
    canAccess,
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    openCreateActionPlanModal: async function () {
      this.resetCreateActionPlanForm();
      await this.getMachinesByCompanyId();
      this.$refs["create-action-plan-modal"].show();
    },
    resetCreateActionPlanForm() {
      this.selectedMachine = {};
      this.selected_aprs = [];
      this.aprs = [];
      this.alert_field = false;
    },
    onMachineChange: async function () {
      this.selected_aprs = [];
      await this.getAPRs();
    },
    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines`,
        {
          params: {
            include: 'protectionSystems,actionPlanAnalyzes',
            company_id: this.localCompanyId,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );

      this.machines = response.data.data.filter(
        (machine) => machine.action_plan_analyzes.length === 0
      );
    },
    getAPRs: async function () {
      if (!this.selectedMachine.id) return;
      await axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/hazards-machine`, {
          machine_id: this.selectedMachine.id,
        })
        .then((response) => {
          this.aprs = response.data.data || response.data;
          this.aprs.forEach((apr) => {
            apr.nameWithMachine = `${apr.number_code} - ${apr.machine.name}`;
          });
        });
    },
    handleCreateActionPlan: async function (bvModalEvt) {
      if (!this.selectedMachine.id || this.selected_aprs.length === 0) {
        bvModalEvt.preventDefault();
        this.alert_field = true;
        this.alert_field_type = "warning";
        this.alert_field_msg = "Selecione a máquina e pelo menos uma APR.";
        return;
      }

      try {
        const loader = this.$loading.show();
        const response = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/action-plan-analyze`,
          {
            name: this.selectedMachine.name,
            machine_id: this.selectedMachine.id,
            hazard_analysis_ids: this.selected_aprs.map((apr) => apr.id),
          }
        );
        loader.hide();
        this.$refs["create-action-plan-modal"].hide();

        // Redireciona para a edição do plano recém-criado
        this.$router.push({
          name: "ActionPlan",
          params: { id: response.data.id, company_id: this.company_id || this.localCompanyId },
        });
      } catch (error) {
        bvModalEvt.preventDefault();
        this.alert_field = true;
        this.alert_field_type = "warning";
        this.alert_field_msg = "Erro ao criar plano de ação.";
      }
    },
     paginate() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      this.$set(this, 'data', this.filteredData.slice(start, end));
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
      this.data = filteredItems.slice(0, this.perPage);
    },
    async bulkCreateActionPlans() {
      const companyId = this.company_id || this.localCompanyId;

      if (!companyId) {
        this.$bvToast?.toast('Selecione uma unidade para criar os planos.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        });
        return;
      }

      const loader = this.$loading.show();
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/action-plan-analyze/bulk-from-company`,
          {
            company_id: companyId,
          }
        );

        this.$bvToast?.toast(
          `Planos processados: criados ${data.created}, atualizados ${data.updated}.`,
          {
            title: 'Planos de Ação',
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-right',
          }
        );

        await this.providerData();
      } catch (error) {
        console.error(error);
        this.$bvToast?.toast(
          error?.response?.data?.message || 'Não foi possível criar planos em massa.',
          {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right',
          }
        );
      } finally {
        loader.hide();
      }
    },
    providerData: function () {
      const loader = this.$loading.show();
      let controller = "";
      let filter = "";
      const companyId = this.company_id || this.localCompanyId;
      const machineId = this.machine_id === "" ? null : this.machine_id;
      let filterForApr = "";
      
      switch (this.docType) {
        case "APR":
          controller = "hazard-analyses";
          filter =
            machineId == "0" || machineId == undefined || machineId == null
              ? `filter[machine.company.id]=${companyId}&include=machine.company`
              : `filter[machine_id]=${machineId}&include=machine.company&`;
          filterForApr = filter;
          break;
        case "Inventory":
          controller = "inventories";
          filter =
            machineId == "0" || machineId == undefined || machineId == null || machineId == ""
              ? `filter[company_id]=${companyId}`
              : `filter[machines.id]=${machineId}&`;
          filterForApr = filter;
          break;
        case "DVS":
          controller = "security-validations";
          filter =
            machineId == "0" || machineId == undefined || machineId == null
              ? `filter[machine.company.id]=${companyId}&include=machine.company,machine.photo`
              : `filter[machine_id]=${machineId}&include=machine.company,machine.photo&`;
          filterForApr = filter;
          break;
        case "Diagnoses":
          controller = "diagnoses";
          filter =
            machineId == "0" || machineId == undefined || machineId == null
              ? `filter[company_id]=${companyId}&include=machine`
              : `filter[machine_id]=${machineId}&include=machine&`;
          this.fields[0] = { key: "machine.name", label: "Máquina" };
          filterForApr = filter;
          break;
        case "ActionPlan":
          controller = "action-plan-analyze";
          filter =
            machineId == "0" || machineId == undefined || machineId == null
              ? `filter[machine.company.id]=${companyId}&include=machine.company,machine.photo`
              : `filter[machine_id]=${machineId}&include=machine.company,machine.photo&`;
          this.fields[0] = { key: "name", label: "Nome" };
          filterForApr = filter;
          break;
        default:
          controller = "corporate-groups";
          filter = "";
          filterForApr = "";
      }

      // let url = this.urlBuild();
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/${controller}?${filter}`,
        {
          params: {
            not_paginated: true,
          },
        }
      );

      promise.then((response) => {
        this.$set(this, 'allData', response.data.data);
        this.$set(this, 'filteredData', response.data.data);
        if (this.docType === 'ActionPlan') {
          this.actionPlanCount = response.data.data.length;
        }

        if(this.docType === 'APR'){
          const sanitizedDataToAPR = response.data.data.map(item => {
            return {
              id: item.id,
              name: `${item.number_code} - ${item.machine?.name}`
            };});
          this.multiselectData = [{ name: 'Todos os Documentos', id: 'all' }, ...sanitizedDataToAPR];
        }
        if(this.docType === 'Inventory'){
          const sanitizedDataToInventory = response.data.data.map(item => {
            return {
              id: item.id,
              name: `${item.number_code}`
            };});
          this.multiselectData = [{ name: 'Todos os Documentos', id: 'all' }, ...sanitizedDataToInventory];
        }
        if(this.docType === 'ActionPlan'){
          const sanitizedDataToActionPlan = response.data.data.map(item => {
            return {
              id: item.id,
              name: `${item.machine?.name}`
            };});
          this.multiselectData = [{ name: 'Todos os Documentos', id: 'all' }, ...sanitizedDataToActionPlan];
        }
        if(this.docType === 'Diagnoses'){
          const sanitizedDataToDiagnoses = response.data.data.map(item => {
            return {
              id: item.id,
              name: `${item.machine?.name}`
            };});
          this.multiselectData = [{ name: 'Todos os Documentos', id: 'all' }, ...sanitizedDataToDiagnoses];
        }
        if(this.docType === 'DVS'){
          const sanitizedDataToDVS = response.data.data.map(item => {
            return {
              id: item.id,
              name: `${item.number_code} - ${item.machine?.name}`
            };});
          this.multiselectData = [{ name: 'Todos os Documentos', id: 'all' }, ...sanitizedDataToDVS];
          this.resumeDocExports('dvs', response.data.data);
        }
        if (this.docType === 'APR') {
          this.resumeDocExports('apr', response.data.data);
        }
        this.rows = this.filteredData.length;
        this.paginate();
        if (this.docType === 'ActionPlan') {
          this.fetchAprCount(filterForApr);
        }
      }).finally(()=>
        loader.hide()
      );
    },
    async fetchAprCount(filterForApr) {
      try {
        const aprResponse = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses?${filterForApr}`,
          { params: { not_paginated: true } }
        );
        this.aprCount = (aprResponse?.data?.data || []).length;
      } catch (error) {
        console.error('Erro ao obter APRs para cálculo do botão em massa', error);
        this.aprCount = 0;
      }
    },

    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    openHazardManagementPlan() {
      this.$router.push("HazardManagementPlan");
    },
    openModal: function (modal, documentId) {
      this.$refs[modal].show();
      this.documentToDelete = documentId;
    },
    checkSuccessNotification() {
      // Verificar notificações de sucesso para diferentes tipos de documentos
      const notifications = [
        { key: 'apr_success_notification', message: 'APR salva com sucesso!' },
        { key: 'inventory_success_notification', message: 'Inventário salvo com sucesso!' },
        { key: 'diagnoses_success_notification', message: 'Diagnóstico salvo com sucesso!' },
        { key: 'actionplan_success_notification', message: 'Plano de Ação salvo com sucesso!' },
        { key: 'machine_success_notification', message: 'Máquina salva com sucesso!' },
        { key: 'dvs_success_notification', message: 'DVS salva com sucesso!' }
      ];
      
      notifications.forEach(notification => {
        if (localStorage.getItem(notification.key) === 'true') {
          this.$bvToast.toast(
            notification.message,
            {
              title: 'Sucesso',
              toaster: "b-toaster-top-right",
              solid: true,
              variant: "success",
              autoHideDelay: 5000
            }
          );
          
          localStorage.removeItem(notification.key);
        }
      });
    },
    deleteDocument() {
      var controller = "";
      switch (this.docType) {
        case "APR":
          controller = "hazard-analyses";
          break;
        case "Inventory":
          controller = "inventories";
          break;
        case "DVS":
          controller = "security-validations";
          break;
        case "Diagnoses":
          controller = "diagnoses";
          break;
        case "ActionPlan":
          controller = "action-plan-analyze";
          break;
      }
      let promise = axios.delete(
        `${process.env.VUE_APP_API_HOST}/api/admin/${controller}/${this.documentToDelete}`
      );
      promise.then(() => {
        this.allData = this.allData.filter((el) => el.id != this.documentToDelete);
        this.filteredData = this.filteredData.filter((el) => el.id != this.documentToDelete);
        this.rows = this.filteredData.length;
        this.paginate();
        this.documentToDelete = null;
      });
    },
    exportInventory(id) {
      window.open(`${process.env.VUE_APP_API_HOST}/export-inventory/${id}.pdf`, '_blank');
    },
    exportAPR(id) {
      return this.exportDocumentPdf('apr', id);
    },
    /**
     * DVS e APR são gerados pelo mesmo fluxo assíncrono; o que muda entre eles é
     * só a rota e o rótulo exibido no aviso.
     */
    documentExportConfig(kind) {
      return kind === 'apr'
        ? { path: 'export-hazard-analysis', label: 'PDF da APR' }
        : { path: 'export-security-validation', label: 'PDF do DVS' };
    },
    getDocExportStorageKey(kind, id) {
      return `${kind}PdfExport:${id}`;
    },
    saveDocExportToStorage(kind, id, payload) {
      localStorage.setItem(this.getDocExportStorageKey(kind, id), JSON.stringify(payload));
    },
    clearDocExportFromStorage(kind, id) {
      localStorage.removeItem(this.getDocExportStorageKey(kind, id));
    },
    downloadGeneratedDocument(kind, url) {
      if (kind === 'apr') {
        // A URL assinada da APR responde como attachment. Navegar até ela inicia
        // o download sem depender de popup, que o navegador pode bloquear porque
        // a conclusão acontece depois de vários ciclos de polling.
        window.location.assign(url);
        return;
      }

      window.open(url, '_blank');
    },
    docExportLabel(id) {
      const state = this.docExportState[id];
      if (!state) {
        return 'Gerando...';
      }
      if (state.progress_percentage) {
        return `${state.current_state || 'Gerando...'} (${state.progress_percentage}%)`;
      }
      return state.current_state || 'Gerando...';
    },
    resumeDocExports(kind, items) {
      items.forEach((item) => {
        if (this.exportingDocIds.includes(item.id)) {
          return;
        }
        const raw = localStorage.getItem(this.getDocExportStorageKey(kind, item.id));
        if (!raw) {
          return;
        }
        let stored;
        try {
          stored = JSON.parse(raw);
        } catch (error) {
          this.clearDocExportFromStorage(kind, item.id);
          return;
        }
        if (!stored || !stored.statusUrl) {
          return;
        }
        this.exportingDocIds.push(item.id);
        this.$set(this.docExportState, item.id, { current_state: null, progress_percentage: 0 });
        this.pollDocumentPdfStatus(kind, stored.statusUrl, item.id).then(() => {
          this.exportingDocIds = this.exportingDocIds.filter((i) => i !== item.id);
          this.$delete(this.docExportState, item.id);
        });
      });
    },
    async exportDVS(id) {
      return this.exportDocumentPdf('dvs', id);
    },
    async exportDocumentPdf(kind, id) {
      if (this.exportingDocIds.includes(id)) {
        return;
      }
      const config = this.documentExportConfig(kind);
      this.exportingDocIds.push(id);
      this.$set(this.docExportState, id, { current_state: null, progress_percentage: 0 });

      const loader = this.$loading.show();
      let data;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_HOST}/${config.path}/${id}.pdf`);
        data = response.data;
      } catch (error) {
        loader.hide();
        this.exportingDocIds = this.exportingDocIds.filter((i) => i !== id);
        this.$delete(this.docExportState, id);
        const message = error.response?.data?.message || `Não foi possível gerar o ${config.label}.`;
        this.$bvToast?.toast(message, {
          title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        });
        return;
      }
      loader.hide();
      this.showAttachmentWarning(data, `${kind}:${id}`);

      if (data.status === 'completed' && data.download_url) {
        this.downloadGeneratedDocument(kind, data.download_url);
        this.exportingDocIds = this.exportingDocIds.filter((i) => i !== id);
        this.$delete(this.docExportState, id);
        return;
      }

      this.$bvToast?.toast(`Gerando o ${config.label} em segundo plano. Você será avisado quando estiver pronto.`, {
        title: 'Exportação', variant: 'info', solid: true, toaster: 'b-toaster-top-right',
      });

      this.saveDocExportToStorage(kind, id, { statusUrl: data.status_url });
      await this.pollDocumentPdfStatus(kind, data.status_url, id);
      this.exportingDocIds = this.exportingDocIds.filter((i) => i !== id);
      this.$delete(this.docExportState, id);
    },
    async pollDocumentPdfStatus(kind, statusUrl, id) {
      if (!statusUrl) {
        return;
      }

      const config = this.documentExportConfig(kind);
      const maxAttempts = 120;
      let attempts = 0;
      let pollDelay = 3000;

      while (attempts < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, pollDelay));

        if (this.componentDestroyed) {
          return;
        }

        try {
          const { data } = await axios.get(statusUrl, { params: { _t: Date.now() } });
          this.showAttachmentWarning(data, `${kind}:${id}`);

          if (id) {
            this.$set(this.docExportState, id, {
              current_state: data.status === 'pending'
                ? 'Aguardando para começar...'
                : data.current_state,
              progress_percentage: data.progress_percentage,
            });
          }

          pollDelay = data.status === 'pending' ? 10000 : 3000;

          if (data.status === 'completed' && data.download_url) {
            if (id) {
              this.clearDocExportFromStorage(kind, id);
            }
            this.$bvToast?.toast(`${config.label} pronto para download.`, {
              title: 'Exportação', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
            });
            this.downloadGeneratedDocument(kind, data.download_url);
            return;
          }

          if (data.status === 'failed') {
            if (id) {
              this.clearDocExportFromStorage(kind, id);
            }
            this.$bvToast?.toast(data.message || data.error_message || `Falha ao gerar ${config.label}.`, {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }
        } catch (error) {
          if (id) {
            this.clearDocExportFromStorage(kind, id);
          }
          this.$bvToast?.toast('Não foi possível consultar o status do PDF.', {
            title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
          });
          return;
        }

        attempts += 1;
      }

      if (id) {
        this.clearDocExportFromStorage(kind, id);
      }
      this.$bvToast?.toast(`A geração do ${config.label} está demorando mais que o esperado. Ela continua em andamento no servidor - reabra esta tela em alguns minutos.`, {
        title: 'Atenção', variant: 'warning', solid: true, toaster: 'b-toaster-top-right',
      });
    },
    showAttachmentWarning(data, context) {
      const warning = data && data.attachment_warning;
      if (!warning) {
        return;
      }

      const fileKey = (warning.files || []).map(file => file.attachment_id || file.name).join('|');
      const key = `${context}:${fileKey}`;
      if (this.attachmentWarningKeys.includes(key)) {
        return;
      }

      this.attachmentWarningKeys.push(key);
      this.$bvToast?.toast(warning.message, {
        title: 'Anexos não incluídos',
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHideDelay: 12000,
      });
    },
    exportDiagnoses(id) {
      window.open(`${process.env.VUE_APP_API_HOST}/export-diagnosis/${id}.xlsx`, '_blank');
    },
    initZipStatus() {
      this.fetchLatestZipStatus();
    },
    async refreshZipStatus() {
      if (!this.zipStatusUrl) {
        return;
      }

      const currentDocType = this.docType;
      
      const typeMap = {
        APR: "apr",
        DVS: "dvs",
        Diagnoses: "diagnostico",
        Inventory: "inventory",
      };
      const expectedType = typeMap[currentDocType];

      try {
        const { data } = await axios.get(this.zipStatusUrl, { params: { _t: Date.now() } });
        this.showAttachmentWarning(data, 'zip:full');
        this.applyZipProgress(data);

        if (data.type && expectedType && data.type !== expectedType) {
          console.warn('Tipo do export não corresponde ao esperado', {
            expected: expectedType,
            received: data.type,
            export_id: data.export_id,
          });
          this.resetZipState();
          localStorage.removeItem(this.getZipStorageKey());
          this.$bvToast?.toast("Tipo de documento não corresponde. Iniciando nova solicitação...", {
            title: "Atenção",
            variant: "warning",
            solid: true,
            toaster: "b-toaster-top-right",
          });
          return;
        }
        
        if (data.status === "completed" && data.download_url) {
          this.zipStatus = "ready";
          this.zipDownloadUrl = data.download_url;
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: this.zipDownloadUrl,
            status_url: this.zipStatusUrl,
          });
          return;
        }

        if (data.status === "failed") {
          this.zipStatus = "error";
          this.zipDownloadUrl = "";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: "",
            status_url: this.zipStatusUrl,
          });
          this.$bvToast?.toast(data.error_message || "Falha ao gerar ZIP.", {
            title: "Erro",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
          });
          return;
        }

        if (data.status === "processing" || data.status === "pending") {
          this.zipStatus = "processing";
          this.zipDownloadUrl = "";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: "",
            status_url: this.zipStatusUrl,
          });
          this.pollZipStatus();
        }
      } catch (error) {
        this.resetZipState();
        localStorage.removeItem(this.getZipStorageKey());
      }
    },
    /**
     * O backend passou a reportar em que documento a geração está; espelhar isso
     * na tela é o que diferencia "está trabalhando" de "travou".
     */
    applyZipProgress(data) {
      this.zipCurrentState = data.status === 'pending'
        ? 'Aguardando para começar...'
        : (data.current_state || "");
      this.zipProgress = data.progress_percentage || 0;
    },
    async fetchLatestZipStatus() {
      const companyId = this.company_id || this.localCompanyId;
      
      const currentDocType = this.docType;
      
      const typeMap = {
        APR: "apr",
        DVS: "dvs",
        Diagnoses: "diagnostico",
        Inventory: "inventory",
      };
      const type = typeMap[currentDocType];
      if (!companyId || !type) {
        return;
      }

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/admin/documents-zip/latest`,
          {
            params: {
              company_id: companyId,
              type,
            },
          }
        );
        this.showAttachmentWarning(data, 'zip:full');
        this.applyZipProgress(data);

        if (data.status === "completed" && data.download_url) {
          this.zipStatus = "ready";
          this.zipDownloadUrl = data.download_url;
          this.zipStatusUrl = "";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: this.zipDownloadUrl,
            status_url: "",
          });
          return;
        }

        if (data.status === "failed") {
          this.zipStatus = "error";
          this.zipDownloadUrl = "";
          this.zipStatusUrl = data.status_url || "";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: "",
            status_url: this.zipStatusUrl,
          });
          return;
        }

        if (data.status === "processing" || data.status === "pending") {
          this.zipStatus = "processing";
          this.zipDownloadUrl = "";
          this.zipStatusUrl = data.status_url || "";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: "",
            status_url: this.zipStatusUrl,
          });
          if (this.zipStatusUrl) {
            this.pollZipStatus();
          }
        }
      } catch (error) {
        // Se não existir export, mantém idle.
      }
    },
    resetZipState() {
      this.zipStatus = "idle";
      this.zipCurrentState = "";
      this.zipProgress = 0;
      this.zipDownloadUrl = "";
      this.zipStatusUrl = "";
    },
    getZipStorageKey() {
      const companyId = this.company_id || this.localCompanyId || "unknown";
      
      const currentDocType = this.docType;
      
      const typeMap = {
        APR: "apr",
        DVS: "dvs",
        Diagnoses: "diagnostico",
        Inventory: "inventory",
      };
      const type = typeMap[currentDocType] || "unknown";
      return `zipStatus:${companyId}:${type}`;
    },
    getZipStatusFromStorage() {
      const key = this.getZipStorageKey();
      const raw = localStorage.getItem(key);
      if (!raw) {
        return null;
      }
      try {
        return JSON.parse(raw);
      } catch (error) {
        return null;
      }
    },
    saveZipStatusToStorage(payload) {
      const key = this.getZipStorageKey();
      localStorage.setItem(key, JSON.stringify(payload));
    },
    openSelectZipModal() {
      this.selectedDocuments = [];
      this.allSelected = false;
      this.$refs['select-zip-modal'].show();
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedDocuments = this.allData.map(d => d.id);
      } else {
        this.selectedDocuments = [];
      }
    },
    getDocumentLabel(item) {
      switch (this.docType) {
        case 'APR':
        case 'DVS':
          return `${item.number_code} - ${item.machine?.name || ''}`;
        case 'Diagnoses':
        case 'ActionPlan':
          return item.machine?.name || item.name || item.id;
        case 'Inventory':
          return item.number_code || item.id;
        default:
          return item.name || item.id;
      }
    },
    async handleSelectZipDownload(bvModalEvt) {
      if (this.selectedDocuments.length === 0) {
        bvModalEvt.preventDefault();
        this.$bvToast?.toast('Selecione ao menos um documento.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-right',
        });
        return;
      }
      await this.downloadSelectedAsZip(this.selectedDocuments);
    },
    async downloadSelectedAsZip(documentIds) {
      const companyId = this.company_id || this.localCompanyId;
      if (!companyId) {
        this.$bvToast?.toast('Selecione uma unidade para exportar.', {
          title: 'Atenção', variant: 'warning', solid: true, toaster: 'b-toaster-top-right',
        });
        return;
      }

      const typeMap = { APR: 'apr', DVS: 'dvs', Diagnoses: 'diagnostico', Inventory: 'inventory' };
      const type = typeMap[this.docType];
      if (!type) return;

      const loader = this.$loading.show();
      let data;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/documents-zip`,
          { company_id: companyId, type, selectedList: true, documentsList: documentIds }
        );
        data = response.data;
        this.showAttachmentWarning(data, 'zip:selected');
      } catch (error) {
        this.$bvToast?.toast(error.response?.data?.message || 'Não foi possível gerar o ZIP dos documentos selecionados.', {
          title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        });
        loader.hide();
        return;
      }
      loader.hide();

      if (data.status === 'completed' && data.download_url) {
        window.open(data.download_url, '_blank');
        return;
      }

      this.$bvToast?.toast('Gerando o ZIP dos documentos selecionados em segundo plano. Você será avisado quando estiver pronto.', {
        title: 'Exportação', variant: 'info', solid: true, toaster: 'b-toaster-top-right',
      });

      this.pollSelectedZipStatus(data.status_url);
    },
    async pollSelectedZipStatus(statusUrl) {
      if (!statusUrl || this.selectedZipPolling) {
        return;
      }

      this.selectedZipPolling = true;
      const maxAttempts = 60;
      let attempts = 0;
      let pollDelay = 3000;

      while (attempts < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, pollDelay));

        if (this.componentDestroyed) {
          this.selectedZipPolling = false;
          return;
        }

        try {
          const { data } = await axios.get(statusUrl, { params: { _t: Date.now() } });
          this.showAttachmentWarning(data, 'zip:selected');
          pollDelay = data.status === 'pending' ? 10000 : 3000;

          if (data.status === 'completed' && data.download_url) {
            this.$bvToast?.toast('ZIP dos documentos selecionados pronto para download.', {
              title: 'Exportação', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
            });
            window.open(data.download_url, '_blank');
            this.selectedZipPolling = false;
            return;
          }

          if (data.status === 'failed') {
            this.$bvToast?.toast(data.error_message || 'Falha ao gerar ZIP dos documentos selecionados.', {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            this.selectedZipPolling = false;
            return;
          }
        } catch (error) {
          this.$bvToast?.toast('Não foi possível consultar o status do ZIP.', {
            title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
          });
          this.selectedZipPolling = false;
          return;
        }

        attempts += 1;
      }

      this.selectedZipPolling = false;
      this.$bvToast?.toast('A geração do ZIP está demorando mais que o esperado. Tente novamente em alguns minutos.', {
        title: 'Atenção', variant: 'warning', solid: true, toaster: 'b-toaster-top-right',
      });
    },
    async downloadDocumentsZip() {
      const companyId = this.company_id || this.localCompanyId;
      if (!companyId) {
        this.$bvToast?.toast("Selecione uma unidade para exportar.", {
          title: "Atenção",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-right",
        });
        return;
      }

      const currentDocType = this.docType;

      const typeMap = {
        APR: "apr",
        DVS: "dvs",
        Diagnoses: "diagnostico",
        Inventory: "inventory",
      };
      const type = typeMap[currentDocType];
      if (!type) {
        return;
      }

      this.zipStatus = "processing";
      this.zipDownloadUrl = "";
      this.zipStatusUrl = "";
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/documents-zip`,
          {
            company_id: companyId,
            type,
          }
        );
        this.showAttachmentWarning(data, 'zip:full');
        this.applyZipProgress(data);

        if (data.status === "completed" && data.download_url) {
          this.zipStatus = "ready";
          this.zipDownloadUrl = data.download_url;
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: this.zipDownloadUrl,
            status_url: "",
          });
          window.open(data.download_url, "_blank");
          return;
        }

        this.zipStatusUrl = data.status_url || "";
        this.saveZipStatusToStorage({
          status: this.zipStatus,
          download_url: "",
          status_url: this.zipStatusUrl,
        });
        this.$bvToast?.toast("Gerando o ZIP completo da empresa em segundo plano. Você será avisado quando estiver pronto.", {
          title: "Exportação",
          variant: "info",
          solid: true,
          toaster: "b-toaster-top-right",
        });

        this.zipPolling = false;
        await this.pollZipStatus();
      } catch (error) {
        console.error("Erro ao solicitar ZIP:", error);
        this.zipStatus = "error";
        this.saveZipStatusToStorage({
          status: this.zipStatus,
          download_url: "",
          status_url: this.zipStatusUrl,
        });
        this.$bvToast?.toast(error.response?.data?.message || "Não foi possível iniciar o ZIP.", {
          title: "Erro",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
        });
      }
    },
    openZipDownload() {
      if (this.zipDownloadUrl) {
        window.open(this.zipDownloadUrl, "_blank");
        return;
      }

      if (this.zipStatusUrl) {
        this.refreshZipStatus();
      }
    },
    async pollZipStatus() {
      if (this.zipPolling) {
        return;
      }

      this.zipPolling = true;
      const maxAttempts = 60;
      let attempts = 0;
      let pollDelay = 3000;

      const companyId = this.company_id || this.localCompanyId;
      const currentDocType = this.docType;

      const typeMap = {
        APR: "apr",
        DVS: "dvs",
        Diagnoses: "diagnostico",
        Inventory: "inventory",
      };
      const type = typeMap[currentDocType];

      while (attempts < maxAttempts) {
        try {
          const { data } = await axios.get(
            `${process.env.VUE_APP_API_HOST}/api/admin/documents-zip/latest`,
            { params: { company_id: companyId, type, _t: Date.now() } }
          );
          this.showAttachmentWarning(data, 'zip:full');
          this.applyZipProgress(data);
          pollDelay = data.status === 'pending' ? 10000 : 3000;

          if (data.status === "completed" && data.download_url) {
            this.zipStatus = "ready";
            this.zipDownloadUrl = data.download_url;
            this.zipStatusUrl = "";
            this.saveZipStatusToStorage({
              status: this.zipStatus,
              download_url: this.zipDownloadUrl,
              status_url: "",
            });
            window.open(data.download_url, "_blank");
            this.zipPolling = false;
            return;
          }

          if (data.status === "failed") {
            this.zipStatus = "error";
            this.zipDownloadUrl = "";
            this.saveZipStatusToStorage({
              status: this.zipStatus,
              download_url: "",
              status_url: "",
            });
            this.$bvToast?.toast(data.error_message || "Falha ao gerar ZIP.", {
              title: "Erro",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-right",
            });
            this.zipPolling = false;
            return;
          }
        } catch (error) {
          console.error("Erro ao consultar status do ZIP:", error);
          this.zipStatus = "error";
          this.saveZipStatusToStorage({
            status: this.zipStatus,
            download_url: "",
            status_url: "",
          });
          this.zipPolling = false;
          return;
        }

        attempts += 1;
        await new Promise((resolve) => setTimeout(resolve, pollDelay));
      }

      // A geração continua no servidor: preservar o status_url é o que permite
      // ao usuário usar "Verificar novamente" (e ao recarregar da página
      // retomar o acompanhamento) em vez de ficar com o botão parado para sempre.
      this.zipStatus = "processing";
      this.saveZipStatusToStorage({
        status: this.zipStatus,
        download_url: "",
        status_url: this.zipStatusUrl,
      });
      this.zipPolling = false;
      this.$bvToast?.toast("O ZIP continua sendo gerado no servidor. Use 'Verificar novamente' em alguns instantes.", {
        title: "Exportação",
        variant: "warning",
        solid: true,
        toaster: "b-toaster-top-right",
      });
    },
    async exportAPRList() {
      try {
        const aprs = this.allData; 

        if (!aprs || aprs.length === 0) {
          alert("Nenhuma APR encontrada para exportação.");
          return;
        }
        const aprRows = aprs.map(apr => ({
          "Código": apr.number_code,
          "Máquina": apr.machine?.name || "",
          "Data de Criação": apr.created_at,
          "Última Atualização": apr.updated_at,
          "Executado em": apr.executed_at || "—",
          "ART": apr.art_number || "—",
          "Empresa": apr.machine?.company?.corporate_name || ""
        }));

        const worksheet = XLSX.utils.json_to_sheet(aprRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "APRs");

        const fileName = `${aprs[0].machine?.company?.corporate_name}_APRs_${new Date().toISOString().slice(0,10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);

      } catch (error) {
        console.error("Erro ao exportar lista de APRs:", error);
        alert("Não foi possível gerar o arquivo Excel. Tente novamente.");
      }
    }
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
    currentPage() {
      this.paginate();
    },
    docType() {
      this.initZipStatus();
    },
    selectedItem(newVal) {
      // Reset to page 1 when filter changes
      this.currentPage = 1;
      
      // Caso nada esteja selecionado, exibe todos os itens
      if (!newVal || newVal.id === 'all') {
        this.$set(this, 'filteredData', [...this.allData]);
      } else {
        // Filtra localmente pelos campos relevantes
        const term = newVal.name?.toLowerCase() || "";
        this.$set(this, 'filteredData', this.allData.filter(item => {
          const byId = item.id === newVal.id;
          const byCode = item.number_code?.toString().includes(term);
          const byMachine = item.machine?.name?.toLowerCase().includes(term);
          return byId || byCode || byMachine;
        }));
      }
      
      this.rows = this.filteredData.length;
      this.paginate();
    },
  },
  computed: {
    computedFields() {
      if (this.docType == "Inventory") {
        // console.log(this.fields.filter((field) => field.label != "Máquina"));
        return this.fields.filter((field) => field.label != "Máquina");
      }

      return this.fields;
    },
    docType() {
      return this.doctype || null;
    },
    documentTypeLabel() {
      const labels = {
        Inventory: "Inventários",
        APR: "APR's",
        ActionPlan: "Planos de Ação",
        Diagnoses: "Diagnósticos",
        DVS: "DVS's",
      };

      return labels[this.docType] || "Documentos";
    },
    shouldShowBulkButton() {
      return this.aprCount > this.actionPlanCount;
    },
    shouldShowZipButton() {
      return ["APR", "DVS", "Diagnoses"].includes(this.docType);
    },
  },
};
</script>
<style scoped>
.zip-item {
  display: block;
  padding-left: 12px;
  white-space: nowrap;
}
</style>
